import { defineComponent as d, inject as l } from "vue";
import { configProviderInjectionKey as u } from "./ghl-ui.es914.js";
import v from "./ghl-ui.es1260.js";
function f(n, t) {
  return d({
    name: v(n),
    setup() {
      var e;
      const o = (e = l(u, null)) === null || e === void 0 ? void 0 : e.mergedIconsRef;
      return () => {
        var r;
        const i = (r = o == null ? void 0 : o.value) === null || r === void 0 ? void 0 : r[n];
        return i ? i() : t;
      };
    }
  });
}
export {
  f as replaceable
};
